import type { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { IntlProvider } from '@skynet/intl-provider';
import { selectLocale } from '../store/selectors';
import type { IntlStore } from '../store/selectors';

/**
 * IntlWrapper component connects Redux locale state to IntlProvider.
 * Reads locale from Redux store and passes it to IntlProvider.
 */
export const IntlWrapper = ({ children }: PropsWithChildren) => {
  const locale = useSelector((state: IntlStore) => selectLocale(state));

  return <IntlProvider locale={locale}>{children}</IntlProvider>;
};
